$(document).on('click', '[data-shoppinglist-object-select]', (event) => {
  event.preventDefault();
  $.ajax({
    method: 'GET',
    url: $(event.currentTarget).attr('href'),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('click', '[data-shoppinglist-object]', (event) => {
  event.preventDefault();
  const $form = $(event.target).closest('form');
  $.ajax({
    method: 'POST',
    url: $form.attr('action'),
    data: $form.serialize(),
  }).done((resp) => {
    $(document).find('[data-shoppinglist-object-container]').html(resp);
    $(document).find('[data-close]').click();
  });
});
